import React from 'react';
import { 
  CloudArrowUpIcon,
  DocumentTextIcon,
  PhotoIcon,
  Squares2X2Icon,
  SwatchIcon,
  CubeIcon,
  Square3Stack3DIcon,
  QuestionMarkCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

interface LeftSidebarProps {
  selectedTool: string;
  onToolSelect: (tool: string) => void;
  onClose?: () => void;
}

const LeftSidebar: React.FC<LeftSidebarProps> = ({
  selectedTool,
  onToolSelect,
  onClose
}) => {
  return (
    <div className="w-24 bg-gray-800 text-white flex flex-col h-full">
      {onClose && (
        <div className="flex justify-end px-2 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1 text-gray-200 transition-colors hover:bg-gray-700 hover:text-white"
            aria-label="Close sidebar"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>
      )}
      {/* Tools Menu - Vertical Icon Layout */}
      <div className="flex-1">
        <div>
          {/* Uploads */}
          <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer ${
              selectedTool === 'uploads' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('uploads')}
          >
            <CloudArrowUpIcon className="w-6 h-6 mb-2" />
            <div className="text-sm">Uploads</div>
          </div>
          
          {/* Text */}
          <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer ${
              selectedTool === 'text' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('text')}
          >
            <DocumentTextIcon className="w-6 h-6 mb-2" />
            <div className="text-sm">Text</div>
          </div>
          
          {/* Shape */}
          <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer ${
              selectedTool === 'shape' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('shape')}
          >
            <PhotoIcon className="w-6 h-6 mb-2" />
            <div className="text-sm">Shape</div>
          </div>
          
          {/* Frame */}
          {/* <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer ${
              selectedTool === 'frame' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('frame')}
          >
            <Squares2X2Icon className="w-6 h-6 mb-2" />
            <div className="text-sm">Frame</div>
          </div> */}
          
          {/* Background */}
          <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer ${
              selectedTool === 'background' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('background')}
          >
            <SwatchIcon className="w-6 h-6 mb-2" />
            <div className="text-sm">Background</div>
          </div>
          
          {/* Product */}
          {/* <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer ${
              selectedTool === 'product' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('products')}
          >
            <CubeIcon className="w-6 h-6 mb-2" />
            <div className="text-sm">Products</div>
          </div> */}
          
          {/* Layers */}
          <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer relative ${
              selectedTool === 'layers' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('layers')}
          >
            <Square3Stack3DIcon className="w-6 h-6 mb-2" />
            <div className="text-sm">Layers</div>
            {/* Warning indicator */}
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 rounded-full flex items-center justify-center text-xs text-black font-bold">!</div>
          </div>
          
          {/* Help */}
          <div 
            className={`flex flex-col items-center py-3 rounded cursor-pointer ${
              selectedTool === 'help' ? 'bg-blue-600' : 'hover:bg-gray-700'
            }`}
            onClick={() => onToolSelect('help')}
          >
            <QuestionMarkCircleIcon className="w-6 h-6 mb-2" />
            <div className="text-sm">Help</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar; 
